import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import { Card, CardActions, CardText, CardTitle } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Divider from 'material-ui/Divider';
import Snackbar from 'material-ui/Snackbar';
import EventIcon from 'material-ui/svg-icons/action/event';
import SecurityIcon from 'material-ui/svg-icons/hardware/security';

import DetailView from '../Common/DetailView';

import { Form } from 'formsy-react';
import { FormsyText as TextField } from 'formsy-material-ui';
import SelectField from '../Common/SelectField';
import MenuItem from 'material-ui/MenuItem';

import AppStore from '../../stores/AppStore';

import AuthActions from '../../actions/AuthActionCreator';
import UserActions from '../../actions/UserActionCreator';
import AttributeStore from '../../stores/AttributeStore';

import buildContextMenu from '../Common/BuildContextMenu';

const Profile = React.createClass({

    getInitialState: function(){

        const user = this.context.auth.getCurrentUser();

        return {

            details: {
                id:        user.id,
                firstName: user.firstName,
                lastName:  user.lastName,
                username:  user.username,
                email:     user.email,
                initials:  user.initials,
                biog:      user.biog,
                attributes: user.attributes || []
            },
            successMessageDuration: 1500,
            showSuccessMessage: false,
            attributes: [],
            actions: [],
            menuItems: [

                {
                    link: '/dashboard/profile/change-password',
                    icon: <SecurityIcon />,
                    label: 'Change password',
                },
                {
                    link: `/dashboard/user/${user.id}/calendar`,
                    icon: <EventIcon />,
                    label: 'Calendar',
                },
                {
                    link: '/logout',
                    icon: <CancelIcon />,
                    label: 'Sign out',
                }
            ],
            dropdowns: {
                titles: [
                    'Mr',
                    'Mrs',
                    'Ms',
                    'Miss',
                    'Doc'
                ]
            },
            links: {
                back: '/dashboard',
                edit: '',
            }
        }
    },


    componentWillMount: function(){
        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});
        AppStore.addFormSubmitSuccessListener(this._onFormSubmitSuccess);

        this.attributeListener = AttributeStore.addListener(this.onAttributesChange);
        UserActions.getUserEditableAttributes();
    },

    componentWillUnmount: function() {
        AppStore.removeFormSubmitSuccessListener(this._onFormSubmitSuccess);
        this.attributeListener.remove();
    },

    render: function() {

        const attributeFields = this.state.attributes.map(({code, name, typeName, isRequired, values}) => {
            switch (typeName) {
                case 'text':
                    return (
                        <div className='cent-col-2'>
                            <TextField
                                name={code}
                                value={this.getAttributeValue(name)}
                                hintText={name}
                                floatingLabelText={name}
                                onChange={this._onTextFieldChange}
                                required={isRequired}
                                fullWidth={true}
                            />
                        </div>
                    );
                case 'option':
                    return(
                        <div className='cent-col-2'>
                            <SelectField
                                name={code}
                                value={this.getAttributeValue(name)}
                                hintText={name}
                                floatingLabelText={name}
                                required={isRequired}

                            >
                                {values.map((v) => <MenuItem key={v} value={v} primaryText={v} />)}
                            </SelectField>
                        </div>
                    );
                default:
                    return null;
            }
        });

        return (
            <DetailView
                title='Profile'
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <Form className="cent-form"
                    onValidSubmit={this._onSave}
                >
                    <div className="cent-cards'">
                    <Card className="cent-card">
                        <CardTitle
                            title='Profile'
                            subtitle='General Information'
                        />
                        <CardText>
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <TextField
                                        name='firstName'
                                        value={this.state.details.firstName}
                                        hintText="First name"
                                        floatingLabelText="First name"
                                        onChange={this._onTextFieldChange}
                                        fullWidth={true}
                                    />
                                </div>
                                <div className='cent-col-2'>
                                    <TextField
                                        name='lastName'
                                        value={this.state.details.lastName}
                                        hintText="Last name"
                                        floatingLabelText="Last name"
                                        onChange={this._onTextFieldChange}
                                        fullWidth={true}
                                    />
                                </div>
                                <div className='cent-col-2'>
                                    <TextField
                                        name='initials'
                                        value={this.state.details.initials}
                                        hintText="Initials"
                                        floatingLabelText="Initials"
                                        onChange={this._onTextFieldChange}
                                    />
                                </div>
                                <div className='cent-col-2'>
                                    <TextField
                                        name='email'
                                        value={this.state.details.email}
                                        hintText="Email"
                                        floatingLabelText="Email"
                                        disabled={true}
                                        fullWidth={true}
                                    />
                                </div>
                                <div className='cent-col-2'>

                                </div>
                                <div className='cent-col-2'>
                                    <TextField
                                        name='username'
                                        value={this.state.details.username}
                                        hintText="Username"
                                        floatingLabelText="Username"
                                        disabled={true}
                                        fullWidth={true}
                                    />
                                </div>
                                <div className='cent-col-1'>
                                    <TextField
                                        name='biog'
                                        value={this.state.details.biog}
                                        hintText="Biog"
                                        floatingLabelText="Biog"
                                        fullWidth={true}
                                    />
                                </div>
                                {attributeFields}
                            </div>
                        </CardText>
                        <Divider  />
                        <CardActions>
                            <FlatButton key="btn_save" label="Save" type="submit" />
                        </CardActions>
                    </Card>
                    </div>
                </Form >

                <Snackbar
                    open={this.state.showSuccessMessage}
                    message="Saved"
                    autoHideDuration={this.state.successMessageDuration}
                    onRequestClose={this._handleSnackbarRequestClose}
                />

            </DetailView>
        )
    },

    _onTextFieldChange: function(event){
        if (this.state.details.hasOwnProperty(event.target.name)) {
            const state = this.state;
            state.details[event.target.name] = event.target.value;
            this.setState(state);
        }
    },

    _onSave: function(data) {
        data.attributes = this.state.attributes.map(({code}) => ({code, value: data[code]}));
        return AuthActions.updateProfile(data);
    },

    _handleSnackbarRequestClose: function() {
        this.setState(assign({}, this.state, { showSuccessMessage: false } ));
    },

    _onFormSubmitSuccess: function() {
        const state = this.state;
        state.showSuccessMessage = true;
        this.setState(assign({}, this.state, state ));
    },

    onAttributesChange: function() {
        const attributes = AttributeStore.getUserEditable();
        if (!!attributes) {
            this.setState({attributes});
        }
    },

    getAttributeValue: function(name) {
        let value = '';
        if (this.state.details.attributes.length > 0) {
            const attribute = this.state.details.attributes.find((a) => a !== undefined && a.name === name);
            if (!!attribute) {
                value = attribute.value;
            }
        }
        return value;
    }

});

Profile.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Profile;
